<template>
	<div class="menus-component">
		<ul class="menus-root">
			<li v-for="(menu,$index) in menus" :key="$index" v-if="!menu.hidden" class="menu-items" @mouseleave="mouseleaveMenuItem()">
				<div class="menu-items-box" 
					@click="selectMenuItem($event,menu,999,$index,'/')" 
					:class="{'menu-items-selected':menu.selected,'menu-items-unselected':!menu.selected}" 
					@mouseover="mouseoverMenuItem($event,menu,999,$index)" 
					>
					<i class="menu-icons">
						<img :src="menu.icon" v-if="!menu.selected">
						<img :src="menu.icon_active" v-else>
					</i>
					<span>{{menu.meta && menu.meta.title}}</span>
				</div>
				<div class="menu-items-childrens" v-show="menu.selected" :style="{top: '0px'}">
					<ul> 
						<li v-for="(children,$key) in menu.children"  
							v-if="!children.hidden"
							:key="$key" 
							class="menu-item-childrens-items" 
							:class="{'menu-items-selected':children.selected,'menu-items-unselected':!children.selected}" 
							@mouseover="mouseoverMenuItem($event,menu,$index,$key)"
							>
							<div class="menu-items-children-box" @click.stop="selectMenuItem($event,children,$index,$key,menu)" >
								<span>{{children.meta && children.meta.title}}</span>
								<span class="meunRight" v-show="children.children && children.children.length"></span>
							</div>
							<div class="menu-items-childrens2 menu-items-childrens"  :style="{top: '0px'}">
								<ul> 
									<li v-for="(itemChild,$key2) in children.children"  
										v-if="!itemChild.hidden"
										:key="$key2" 
										class="menu-item-childrens-items" 
										:class="{'menu-items-selected':itemChild.selected,'menu-items-unselected':!itemChild.selected}" 
										>
										<div class="menu-items-children-box" @click.stop="selectMenuItem($event,itemChild,$key,$key2,children)" >
											<span>{{itemChild.meta && itemChild.meta.title}}</span>
										</div>
									</li>
								</ul>
							</div> 
						</li>
					</ul>
				</div>
			</li>
		</ul>
	</div>
</template>
<script>
// require('@/a')
import { mapGetters } from 'vuex'

export default {
	name: 'MenusComponent',
	props: ['parent', 'children'],
	components: {},
	computed: {
		...mapGetters([
			'permission_routes',
		]),
	},
	data() {
		return {
			menus:[],
			meunRight:''
		}
	},
	created() {
		this.meunRight=require('../assets/images/menuRight.png')
		this.menus = this.permission_routes
	},
	methods: {
		mouseoverMenuItem(e, item, parent, index) {
			if (parent != 999) {
				this.menus[parent].children.forEach(menu => {
					menu.selected = false;
				})
				this.menus[parent].children[index].selected = true
			} else {
				this.menus.forEach(menu => {
					menu.selected = false;
				})
				this.menus[index].selected = true;
			}
			this.menus = JSON.parse(JSON.stringify(this.menus))
		},
		mouseleaveMenuItem() {
			this.menus.forEach(menu => {
				menu.selected = false;
			})
		},
		selectMenuItem(e, item, parent, index,parentItem) {
			if (parent != 999) {
				this.$store.dispatch('common/addTab', {
					title: item.meta && item.meta.title,
					path: item.path,
					name: item.name
				})
			}
		},
		filterAsyncRouter(routers) { 

			return routers.filter(router => {
				router.selected=false;
				
				if(router.code=="business"||router.code=="finance"||router.code=="report"||router.code=="appuser"||router.code=="system"){

					router.icon=require(`../assets/images/menu-icons/icon_${router.code}_20_20.png`);
					router.icon_active=require(`../assets/images/menu-icons/icon_${router.code}_hover_20_20.png`);
				}
				if (router.component) {
					if (router.component === 'Layout') { // Layout组件特殊处理
						router.component = Layout
					} else {
						
						const component = router.component
						router.component = loadView(router.code)
					}
				}
				
				if (!router.path) {
					router.path=router.code;
				}

				if (router.children && router.children.length) {	
					router.children == this.filterAsyncRouter(router.children)
				}
				return true
			})
		},
		loadView(view){
			return (resolve) => require([`@/views/${view}`], resolve)
		}
	},
	mounted() {
		let _this = this;
		window.addEventListener('click', function(e) {
			_this.menus.forEach(menu => {
				menu.selected = false
			})
		}, false)
	}
}

</script>
<style scoped lang="scss">
.menus-component {
  width: 100%;
  height: auto;
  background: #fff;
}

.menus-component ul {
  width: 100%;
  height: auto;
}

.menus-component>ul>li {
  display: block;
  width: 100%;
  height: 60px;
}

.menu-items {
  position: relative;
}

.menu-icons {
  display: block;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 3px;
  top: 20px;
}

.menu-icons img {
  display: block;
  width: 100%;
}

.menus-component ul li .menu-items-box {
  /* width: 71%; */
  height: 60px;
  line-height: 60px;
  padding: 0 0 0 25px; 
  font-size: 16px;
  font-weight: 400;
}
.menus-component ul li .menu-items-box  span{
 /* width: 100px; */
 display: inline-block;
 height: 60px;
  line-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.menus-component ul li .menu-items-box:hover {
  cursor: pointer;
}

.menu-items-box.menu-items-unselected {
  color: rgba(50, 50, 50, 1);
  background: #FFF;
}

.menu-items-box.menu-items-selected {
  color: #FFF;
  background: #FF5B3E
}
/* .menu-items-box.menu-items-unselected {
  color: rgba(50, 50, 50, 1);
  background: #FFF;
}

.menu-items-box.menu-items-selected {
  color: #FFF;
  background: #FF5B3E
} */

.menu-items-childrens {
  width: 144px;
  background-color: #FF5B3EFF;
  position: absolute;
  left: 100%;
  top: 0;
  z-index: 9999;
  /* padding: 8px 0; */
}
// .menu-items-childrens2 {
//   left: 100%;
// }

.menu-item-childrens-items {
  height: 38px;
  line-height: 38px;
  padding-left: 24px;
  position: relative;
  color: #fff;
}
.menu-item-childrens-items::before{
	content: "";
	width: 4px;
	height: 4px;
	border-radius: 50px;
	position: absolute;
	left: 10px;
	top: 50%;
	margin-top: -2px;
	background-color: #fff;
}
.menu-item-childrens-items:hover {
  cursor: pointer;
  color: #FFDD8FFF;
}
.menu-item-childrens-items>.menu-items-childrens{
	display: none;
}
.menu-item-childrens-items:hover>.menu-items-childrens{
	display: block;
}
.menu-item-childrens-items:hover::before{
	background-color:#FFDD8FFF;
}
.menu-items-children-box {
//   width: 110px;

  height: 38px;
  line-height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.meunRight{
	display: inline-block;
	width: 20px;
	height: 20px;
	background: url('../assets/images/menuRight.png') center no-repeat;
	background-size: 100% 100%;
}
</style>
